// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-card[data-v-4211a285]{max-width:60%;min-width:10rem}@media only screen and (max-width:768px){.modal-card[data-v-4211a285]{max-width:90%}}.modal-card-body[data-v-4211a285]{flex-direction:column;min-height:12rem}.input[data-v-4211a285]{min-width:10rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
